export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker не поддерживается')
    return
  }

  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/service-worker.js')
      console.log('[SW] Зарегистрирован:', reg.scope)
    } catch (err) {
      console.error('[SW] Ошибка регистрации:', err)
    }
  })
}